import { ALLOW_COOKIE } from 'constants';
import Storage from 'utilities/storage';

export const removeSessionCookies = () => {
    if (!ALLOW_COOKIE) return;

    if (Storage.cookies.get('accessToken')) {
        Storage.cookies.remove('accessToken');
    }

    if (Storage.cookies.get('refreshToken')) {
        Storage.cookies.remove('refreshToken');
    }

    if (Storage.cookies.get('openBankToken')) {
        Storage.cookies.remove('openBankToken');
    }
};
